import { useState, useEffect } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Surface,
  Symbols,
} from "recharts";
import { colors } from "./colors";
import { useStyles } from "./styles";

export function BarStacked({ data = [], bars = [], nameKey }) {
  const styles = useStyles();
  const [activeLegend, setActiveLegend] = useState(bars);
  const [chartBars, setChartBars] = useState(bars);
  const [disabledLegend, setDisabledLegend] = useState([]);

  useEffect(() => {
    const tempBar = bars.map((bar, index) => ({
      name: bar,
      color: colors[index % colors.length],
    }));

    setActiveLegend(tempBar);
    setChartBars(tempBar);
  }, [bars]);

  function _filterChart(value) {
    let _disabled = [];
    if (disabledLegend.includes(value)) {
      _disabled = disabledLegend.filter((idDisabled) => idDisabled !== value);
    } else {
      _disabled = disabledLegend.concat(value);
    }
    const newChartBars = activeLegend.filter(
      (dt) => !_disabled.includes(dt.name)
    );
    setChartBars(newChartBars);
    setDisabledLegend(_disabled);
  }

  function LegendComponent({ payload }) {
    return (
      <div className={styles.rootLegend}>
        {payload.map((entry, index) => {
          const { color, name } = entry,
            active = disabledLegend.includes(name),
            style = { color: active ? "#AAA" : "#000" };

          return (
            <span
              key={index.toString()}
              className={styles.textLegend}
              style={style}
              onClick={() => _filterChart(name)}
            >
              <Surface
                width={10}
                height={10}
                viewBox={{ x: 0, y: 0, height: 10, width: 10 }}
              >
                <Symbols cx={5} cy={5} type="circle" size={50} fill={color} />
                {active && (
                  <Symbols
                    cx={5}
                    cy={5}
                    type="circle"
                    size={25}
                    fill={"#FFF"}
                  />
                )}
              </Surface>
              <span>{name}</span>
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <ResponsiveContainer height="100%" width="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={nameKey} />
          <YAxis />
          <Tooltip contentStyle={{ borderRadius: 15 }} />
          <Legend
            verticalAlign="bottom"
            payload={activeLegend}
            content={LegendComponent}
          />
          {chartBars.map((bar, index) => (
            <Bar
              key={index.toString()}
              dataKey={bar.name}
              fill={bar.color}
              radius={[5, 5, 0, 0]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
